import { getBike, setBike, MY_BIKE_EVENT } from '@theme/my-bike';

/**
 * Home hero bike finder (sections/voge-hero.liquid).
 * Choosing a model and submitting saves it as "My bike" (assets/my-bike.js, same storage the header
 * selector and fit badges use) and opens the model collection. The select starts on the saved bike
 * and the button reads "Show parts for my <model>" once a model is chosen.
 * Without JS the form opens the collection list page.
 */
class BikeFinder extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;
    this.form = this.querySelector('form');
    this.select = /** @type {HTMLSelectElement | null} */ (this.querySelector('[data-finder-select]'));
    if (!this.form || !this.select) return;

    this.form.addEventListener('submit', this.#onSubmit, { signal });
    this.select.addEventListener('change', () => this.#onChange(), { signal });
    document.addEventListener(MY_BIKE_EVENT, () => this.#syncFromBike(), { signal });
    this.#syncFromBike();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #syncFromBike() {
    const bike = getBike();
    if (bike && this.select) {
      const option = Array.from(this.select.options).find((item) => item.dataset.id === String(bike.id));
      if (option) this.select.value = option.value;
    }
    this.#updateLabel();
  }

  #onChange() {
    this.#showError(false);
    this.#updateLabel();
  }

  #updateLabel() {
    const label = this.querySelector('[data-finder-label]');
    if (!label || !this.select) return;
    const option = this.select.selectedOptions[0];
    label.textContent =
      option && option.value
        ? (this.dataset.submitModel || '[model]').replace('[model]', option.dataset.title || option.text)
        : this.dataset.submit || label.textContent || '';
  }

  /** @param {boolean} show */
  #showError(show) {
    const error = /** @type {HTMLElement | null} */ (this.querySelector('[data-finder-error]'));
    if (error) error.hidden = !show;
    this.select?.setAttribute('aria-invalid', String(show));
  }

  /** @param {SubmitEvent} event */
  #onSubmit = (event) => {
    event.preventDefault();
    const option = this.select?.selectedOptions[0];
    if (!option || !option.value) {
      this.#showError(true);
      this.select?.focus();
      return;
    }
    const { id = '', handle = '', title = option.text } = option.dataset;
    setBike({ id, handle, title, url: option.value });
    window.location.assign(option.value);
  };
}

if (!customElements.get('bike-finder')) customElements.define('bike-finder', BikeFinder);
